import { render } from "./UserBalance.vue?vue&type=template&id=64c61341&scoped=true&ts=true"
import script from "./UserBalance.vue?vue&type=script&lang=ts"
export * from "./UserBalance.vue?vue&type=script&lang=ts"

import "./UserBalance.vue?vue&type=style&index=0&id=64c61341&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c61341"]])

export default __exports__